import { render, staticRenderFns } from "./AuthorCourseRelevance.vue?vue&type=template&id=78a69a20&scoped=true"
import script from "./AuthorCourseRelevance.vue?vue&type=script&lang=js"
export * from "./AuthorCourseRelevance.vue?vue&type=script&lang=js"
import style0 from "./AuthorCourseRelevance.vue?vue&type=style&index=0&id=78a69a20&prod&lang=scss&scoped=true"
import style1 from "./AuthorCourseRelevance.vue?vue&type=style&index=1&id=78a69a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a69a20",
  null
  
)

export default component.exports